import React, { useContext, useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Sidebar from './../Sidebar';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { site_url, truck, site_url_img } from "../config.js";
import Footer from '../Footer';
import { useNavigate } from 'react-router-dom';

import './app.css'
const PendingBillPayment = () => {
  const [totalPaid, setTotalPaid] = useState(0);
  const [remaining, setRemaining] = useState(0);
  const [bills, setBills] = useState([]);
  const [totalPending, setTotalPending] = useState(0);
  const queryParams = new URLSearchParams(useLocation().search);
  const id = queryParams.get('id');
  const shopName = queryParams.get('shop_name');
  const navigate = useNavigate();

  const { user } = useContext(AuthContext);
  const [sales_payment_type, setsales_payment_type] = useState('cash');
  const [notes, setNotes] = useState('');
  const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
  const [startDate, setStartDate] = useState(today);

  useEffect(() => {
    axios.get('https://mkbmaligai.in/api/allbillpayment/'+id)
      .then(res => {
        // const billData = res.data.bill.map(bill => ({
        //   ...bill,
        //   paid_amount: 0 // initialize local paid_amount
        // }));
        // const pendingSum = billData.reduce((sum, b) => sum + Number(b.balance_amount), 0);
        setTotalPending(res.data.pending_amount);
        setBills(res.data.pending_amount);
      })
      .catch(err => console.error('API Error:', err));
  }, [id]);

  useEffect(() => {
    autoFillBills();
  }, [totalPaid]);
  useEffect(() => {
    // Update remaining whenever totalPaid or totalPending changes
    const calculatedRemaining = totalPending - totalPaid;
    setRemaining(calculatedRemaining > 0 ? calculatedRemaining : 0);
  }, [totalPaid, totalPending]);
  const autoFillBills = () => {
    let left = totalPaid;
    // const updated = bills.map(bill => {
    //   const toPay = Math.min(bill.balance_amount, left);
    //   left -= toPay;
    //   return { ...bill, paid_amount: toPay };
    // });
    setBills('');
    setRemaining(left);
  };

  const handlePaidAmountChange = (index, value) => {
    const updated = [...bills];
    const bill = updated[index];
  
    // Remove leading zeros (but allow just "0" when input is empty)
    const cleanedValue = value.replace(/^0+(?=\d)/, '');
  
    // // If cleaned value is empty, set to "0"
    // const newValue = cleanedValue === '' ? 0 : Number(cleanedValue);
  
    // // Prevent overpay
    // if (newValue > bill.balance_amount) return;
  
    // bill.paid_amount = newValue;
    // updated[index] = bill;
  
    // const totalUsed = updated.reduce((sum, b) => sum + Number(b.paid_amount || 0), 0);
    // setRemaining(totalPaid - totalUsed);
    setBills('');
  };
  
  const formatINR = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 2
    }).format(amount);
  };

  const handleSubmit = async () => {
    try {
      if (totalPaid <= 0) {
        alert('Please enter Total Paid Amount');
        return;
      }
  
      const confirmSubmit = window.confirm('Are you sure you want to submit this payment?');
      if (!confirmSubmit) {
        return; // If user clicks "Cancel", stop here
      }
  
      const data = {
        bills: totalPaid,
        userid: user.id,
        sales_type: sales_payment_type,
        sales_shop_id:id,
        billdate:startDate,
        notes:notes
      };
  
      console.log('Submitting:', data);
  
      const response = await axios.post(site_url + '/updateallbillpayment', data);
  
      console.log('Success:', response.data);
      
      alert('Payment updated successfully!');
      navigate(-1);
    } catch (error) {
      console.error('Error updating payments:', error);
      alert('Something went wrong while updating payments.');
    }
  };
  
  
  return (
    <div className="max-w-4xl mx-auto mt-10 p-6 bg-white shadow-lg rounded-lg">
      <br></br>
      <h2 className="text-xl font-bold mb-4 text-danger" style={{marginTop:'15%'}}>{shopName} / {formatINR(totalPending)}</h2>

      <div className="mb-4">
        <label className="block font-medium mb-1">Total Paid Amount (₹)</label>
        <input
          type="number"
          value={totalPaid}
          onChange={(e) => setTotalPaid((e.target.value))}
          className="w-full border border-gray-300 p-2 rounded"
          placeholder="Enter total paid amount"
        />
        
      </div>
      <div className="mb-4">
      <select value={sales_payment_type}
            onChange={(e) => setsales_payment_type(e.target.value)} 
             id="paymentMode" name="payment_type" class="form-select form-control" required="">
                            <option value="cash">Cash</option>
                            <option value="bank">Bank</option>
                            <option  value="return">Return</option>
                        </select>
      </div>
      <div class="form-group">
  <label>Date</label>
  <input
        type="date"
        className="form-control"
        id="myDate"
        value={startDate}                // use value, not selected
        onChange={(e) => setStartDate(e.target.value)}
      />
      </div>
<div class="form-group">
  <label for="notes">Notes</label>
  <textarea name="notes" id="notes"  value={notes} onChange={(e) => setNotes(e.target.value)} class="form-control" placeholder="Enter Notes"></textarea>
</div>


      <div className="mb-4 text-sm text-blue-600" >
       <p> Remaining balance to distribute: <span style={{color:'blue'}}>{formatINR(remaining)}</span></p>
      </div>
      <div className="mb-4 text-sm text-gray-600">
      <p> Total Pending Amount from Bills: <span style={{color:'red'}}>{formatINR(totalPending)}</span></p>
</div>
<center>

       
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 btn btn-danger"
          onClick={handleSubmit}
        >
          Save Payment
        </button> </center>
      

      <div className="mt-6 text-right">
        
      </div>
      <Sidebar />
      <Footer />
    </div>
  );
};

export default PendingBillPayment;
